import { initMenuButton } from './MenuButton';
import { initFlyoutMenu } from './FlyoutMenu';
import { initMobileMenuToggle } from './MobileMenuToggle';
import { initMobileNavigation } from './MobileNavigation';

export const initHeader = () => {
    const header = document.querySelector('#header');
    if (!header) return;

    let hasMenuButtonAndFlyout = false;

    // Use a resize observer instead of the window resize event.
    const resizeObserver = new ResizeObserver(entries => {
        if (entries[0].target === header) {
            if (hasMenuButtonAndFlyout || (document.documentElement.offsetWidth || 0) < 1024) return;
            initMenuButton(header);
            initFlyoutMenu(header);
            hasMenuButtonAndFlyout = true;
        }
    });

    resizeObserver.observe(header);

    initMobileMenuToggle(header);
    initMobileNavigation(header);
};
